import { webApiEndpoints } from "../config/webApiRequest.config"
import { mapper } from "../helpers/mapper.helper"
import { AppRequestType, CatalogRootType, PathAppOptions, CatalogGenericType } from "../types"

type ActionItemGroupType = 'add' | 'edit' | 'update' | 'delete';

function actionItemGroup<T>(groupId: string, action: ActionItemGroupType, item: unknown, mapHelper: (data: unknown) => T): AppRequestType<T>['catalog']['add'] {
    let pathVariables: Map<PathAppOptions, string> = new Map();
    pathVariables.set('{groupId}', groupId);
    return ({
        endpoint: webApiEndpoints.catalog[action],
        parameters: { pathVariables },
        input: item,
        output: (datos) => mapHelper(datos)
    })
}

export const catalogAdapter = {
    getData: (hideError?: Boolean): AppRequestType<CatalogRootType>['catalog']['getAppBase'] => ({
        endpoint: webApiEndpoints.catalog.getAppBase,
        input: null,
        hideError: !!hideError,
        keepCacheBeforeNewRequest: true,
        output: (datos) => mapper.apiCatalogRoot(datos)
    }),

    listAllGroupData: (): AppRequestType<CatalogGenericType>['catalog']['getGroups'] => ({
        endpoint: webApiEndpoints.catalog.getGroups,
        input: null,
        keepCacheBeforeNewRequest: true,
        output: (datos) => mapper.apiCatalogGeneric(datos)
    }),

    actionItemGroup
}
